module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIxMyIgY3k9IjEzIiByPSIxMi41IiBzdHJva2U9IiNGRjAwMDAiLz4KICA8cmVjdCB4PSI1IiB5PSI2LjQxNDA2IiB3aWR0aD0iMiIgaGVpZ2h0PSIyMSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDUgNi40MTQwNikiIGZpbGw9IiNGRjAwMDAiLz4KICA8cmVjdCB4PSIxOS44NDkxIiB5PSI1IiB3aWR0aD0iMiIgaGVpZ2h0PSIyMSIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTkuODQ5MSA1KSIgZmlsbD0iI0ZGMDAwMCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/warn.svg
// module id = kHD4
// module chunks = 0